const panelMargin = '2px';

export default ({ dropdown }) => ({
  panel: {
    position: 'absolute',
    width: '100%',
    right: 0,
    top: 'auto',
    zIndex: 1,
    marginTop: panelMargin,
    boxShadow: '0 0 10px 0 rgba(0,0,0,0.3)',
    '&.direction-up': {
      bottom: '100%',
      marginTop: 0,
      marginBottom: panelMargin
    },
    '&.direction-right': {
      right: 0
    },
    '&.direction-left': {
      left: 0,
      right: 'auto'
    },
    '&.direction-center': {
      margin: [0, -160],
      right: '50%'
    },
    '&.screen-reader-label': {
      top: 36
    }
  },
  root: {
    '&$dark': {
      background: dropdown.dark.background
    },
    background: dropdown.background,
    border: `1px solid ${dropdown.border}`,
    paddingTop: 8,
    borderRadius: 3,
    overflow: 'hidden'
  },
  scroll: {
    paddingBottom: 8,
    maxHeight: 200,
    overflowY: 'auto',
    '-ms-overflow-style': 'none'
  },
  noresults: {
    '&$dark': {
      color: dropdown.dark.text
    },
    color: dropdown.text,
    margin: [10, 12, 4, 12],
    fontSize: 14
  },
  loading: {
    margin: [10, 0]
  },
  dark: {},
  end: {
    height: 1 // needs a height for firefox to "see" it
  }
});
